import { UIHeading1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as style from './NewbuildingPushToCallBanner.css';

interface INewbuildingPushToCallBannerProps {
  isFullscreen: boolean;
}

export const NewbuildingPushToCallBanner = ({
  children,
  isFullscreen,
}: React.PropsWithChildren<INewbuildingPushToCallBannerProps>) => {
  return (
    <div
      className={cx(style['container'], isFullscreen && style['container--fullscreen'])}
      data-testid="NewbuildingPushToCallBanner"
    >
      <div className={style['image']} />
      <div className={style['actions']}>
        <UIHeading1 textAlign="center">
          Если понравилась квартира, <br />
          позвоните застройщику
        </UIHeading1>
        <div data-testid="PushToCallButton">{children}</div>
      </div>
    </div>
  );
};
